import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextButton } from "../../../ui/input/TextButton";
import { setScene } from "../../../ui/scene";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { Main } from "../../scenes/main";

export const VictoryModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  floodFill(C.display, C.bounds, Colors.OFF_BLACK);
  C.handlers.keypress = (key: string) => {
    if (key === "Enter") {
      return false;
    }
    return true;
  };

  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      { title: "VICTORY", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 1, y: 1, w: C.bounds.w - 2, h: C.bounds.h - 2 },
      {
        title: `%c{${Colors.GRAY_3}}You have mastered the art of spelling and become a powerful wizard! With the dastardly Mote defeated you set off on a new adventure.`,
      }
    ),
    createElement(
      TextType,
      { x: 1, y: 8, w: C.bounds.w - 2, h: C.bounds.h - 2 },
      {
        title: "Thank you for playing, find me on Twitter @IAmSlogo.",
      }
    ),
    createElement(
      TextButton,
      { x: 1, y: C.bounds.h - 2, w: C.bounds.w - 2, h: 1 },
      {
        title: "End Game",
        keyLabel: "Esc",
        keys: ["Escape"],
        onClick: () => {
          closeModal();
          setScene(new Main());
        },
      }
    ),
  ];
};
